module.exports = __webpack_public_path__ + "static/media/ico-floating-community-active.cc80a15d.svg";